import { GET_TRADE_PAIR_REQUEST, GET_TRADE_PAIR_SUCCESS, GET_TRADE_PAIR_ERROR } from "../../Actions/TradePairs/TradePairAction";

const initialState = {
    tradePairLoading: false,
    tradePairData: null,
    tradePairError: null,
    tradePairStatus: null
};

export default function TradePairReducer(state = initialState, action) {
    switch (action.type) {

        case GET_TRADE_PAIR_REQUEST:
            return { ...state, tradePairLoading: true };

        case GET_TRADE_PAIR_SUCCESS:
            return { ...state, tradePairLoading: false, tradePairData: action.payload, tradePairStatus: true };

        case GET_TRADE_PAIR_ERROR:
            return { ...state, tradePairLoading: false, tradePairError: action.payload, tradePairStatus: false };

        default:
            return state;
    }
}